
import { useState, useRef, useEffect } from '../../common/common';
import useGetUserData from '../../secureAPI/GetUserData';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import Navigations from '../../common/useNavigation.js';
import axiosJWT from '../../secureAPI/axiosJWT.js';
const MidEmailOTP = () => {
  const { users } = useGetUserData();
  const { navigateSellerProductAttributes, navigateUserType } = Navigations();
  const [isLoading, setisLoading] = useState(false);
  const [isDisabled, setisDisabled] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [activeOtpIndex, setactiveOtpIndex] = useState(0);

  // State for OTP timer and resend button visibility
  const [timer, setTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    const checkUserIsOTPVerified = () => {
      if (users?.length > 0) {
        if (users[0]['IsOTPVerified'] === 1) {
          navigateSellerProductAttributes();
        }
      }
    };
  
    if (Array.isArray(users) && users.length > 0) {
      checkUserIsOTPVerified();
    }
  }, [users,navigateSellerProductAttributes]); // Only users is needed as dependency now

  // useEffect(() => {
  //   //  console.log('called useeffectsss');
  //   if (Array.isArray(users) && users.length > 0) {
  //     checkUserIsOTPVerified();
  //   }
  // }, [users]);

  // const checkUserIsOTPVerified = () => {
  //   if (users?.length > 0) {
  //     if (users[0]['IsOTPVerified'] === 1) {
  //       navigateSellerProductAttributes();
  //     }
  //   }
  // };


  // Function to handle OTP resend
  const resendOTP = async () => {
    setTimer(60); // Reset timer to 60 seconds
    setIsResendDisabled(true); // Disable resend button again
    try {
      // API call to send OTP (you will need to replace this URL with your actual API endpoint)
      await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/ResendEmailOTP`, {app:0}, { withCredentials: true }).then((res) => {
        StopLoading(setisLoading, setisDisabled);
        if (res.data.success === 1) {
          showToast(res.data.message, 'success');
        }
        else {
          showToast(res.data.message, 'error');
        }
      }).catch((err) => {
        StopLoading(setisLoading, setisDisabled);
        showToast('Error during OTP submission', 'error');
      });
    } catch (error) {
      showToast('Error in OTP API call:', 'error');
    }
  };

  useEffect(() => {
    // Only start the countdown if the timer is above 0
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000); // Decrease the timer by 1 every second

      // Clear interval when the timer reaches 0
      return () => clearInterval(interval);
    } else {
      setIsResendDisabled(false); // Enable the resend button when the timer hits 0
    }
  }, [timer]);


  const inputRef = useRef(null);
  let currentOTPIndex = 0;

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeOtpIndex]);

  const handleOnChange = (e) => {
    const values = e.target.value;
    const newOtp = [...otp];

    // Update the OTP value with the last digit entered
    newOtp[currentOTPIndex] = values.substring(values.length - 1);

    // Move to next input if there's a value, else stay on the current one
    if (values) {
      setactiveOtpIndex(currentOTPIndex + 1);
    } else {
      setactiveOtpIndex(currentOTPIndex - 1);
    }

    setOtp(newOtp);
  };

  const handleOnKeyDown = ({ key }, index) => {

    currentOTPIndex = index;
    // console.log(index);
    if (key === "Backspace") {
      const newOtp = [...otp];
      // console.log({newOtp:newOtp});
      newOtp[currentOTPIndex] = ""; // Clear the current input value

      // Move to the previous input only if we're not at the first input
      if (currentOTPIndex > 0) {
        setactiveOtpIndex(currentOTPIndex - 1); // Move to the previous input
      }

      setOtp(newOtp);  // Apply the OTP state change
    }
  };
  const handlesubmit = e => {
    e.preventDefault();
    SubmitOTP(); // Assuming checkLogin() is a function to handle actual login logic
  };


  const handleOTPVerifyError = (err) => {
    // console.error(err);
    showToast('Something went wrong! Please try again laterrrrr', 'error');
    StopLoading(setisLoading, setisDisabled);
  };

  const SubmitOTP = async () => {

    StartLoading(setisLoading, setisDisabled);
    try {
      const otps = otp.map(num => parseInt(num, 10));
      await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/OTPverify`, { otps }, { withCredentials: true }
      ).then((res) => {
        StopLoading(setisLoading, setisDisabled);
        if (res.data.success === 1) {
          showToast(res.data.message, 'success');
          setTimeout(() => {
            navigateUserType();
          }, 3000);
        }
        else {
          showToast(res.data.message, 'error');
        }
      }).catch((err) => {
        StopLoading(setisLoading, setisDisabled);
        showToast('Error during OTP submission', 'error');
      });
    } catch (err) {
      // console.error('Error during OTP submission:', err);
      handleOTPVerifyError(err);
    }

    // const handleSuccessfulProductAttributes = (result) => {
    //   const { message, data } = result;
    //   showToast(message, 'success');
    //   navigateSellerPersonaldetails();
    //   // You can also redirect or do other actions here if necessary
    // };

    // const handleOTPVerifyResponse = (res) => {
    //   console.log(res);
    //   const result = res.data;
    //   if (result.success === 1) {
    //     handleSuccessfulProductAttributes(result);
    //   } else {
    //     showToast(result.message, 'error');
    //   }
    //   StopLoading(setisLoading, setisDisabled);
    // };
  };

  return { users,otp, setOtp, activeOtpIndex, setactiveOtpIndex, handleOnKeyDown, handleOnChange, inputRef, handlesubmit, isLoading, isDisabled, timer, isResendDisabled, setIsResendDisabled, resendOTP }
}

export default MidEmailOTP